import IndustryDetailPage from "@/pages/industries/components/IndustryDetailPage";

export default function HealthcarePage() {
  return <IndustryDetailPage slug="healthcare" />;
}